import React from 'react';
import { useLocation } from 'react-router-dom';

import ReportGenerator from '../../common/ReportGenerator/ReportGenerator.module';

const CoproReport: React.FC = () => {
  const location = useLocation(); // Initialize useLocation
  const { selectedCoproId } = location.state || {}; // Extract coproId from state

  const getReportUrl = (companyId: string, coproId: string) => `/api/companies/${companyId}/copros/${coproId}/report/generate`;

  return (
    <ReportGenerator
      description="Cette page vous permet de générer des rapports détaillés pour vos copropriétés. Ces rapports incluent les 6 dernières ventes et les 6 derniers DPEs de la copropriété sélectionnée ainsi que les points d'intérêt autour d'elles et des informations sur la copropriété."
      getReportUrl={getReportUrl}
      generatedPdfFileName="presentation_copropriete"
      initialCoproId={selectedCoproId || null}
      hasSalesRadiusOption
    />
  );
};

export default CoproReport;
